module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor_magicbook_en-61df93a1945bf49f05a67b03c5c5991b.jpg";